import { A } from "@angular/cdk/keycodes";
import { ReportOutputFormat, TemplateSiteDirective } from "@scisys-uim/uim-common";

export function openAsHtmlEmail(toAddress: string, ccAddress: string, subject: string, emailBodyHtml: string, filenamePrefix: string) {
  //emailBodyHtml = TemplateSiteDirective.sanitiseHtml(emailBodyHtml);
  const emailBodyAsDom = document.createElement('div');
  emailBodyAsDom.innerHTML = emailBodyHtml;
  TemplateSiteDirective.processDom(emailBodyAsDom);
  emailBodyHtml = emailBodyAsDom.innerHTML;

  var email = "To: " + toAddress + "\n";
  if (ccAddress != null) {
    email += "Cc: " + ccAddress + "\n";
  }
  email += "Subject: " + subject + "\n";
  email += "X-Unsent: 1\n";
  email += "Content-Type: text/html\n";
  email += "\n";
  email += emailBodyHtml;

  var data = new Blob([email], { type: 'text/plain' });
  var textFile = window.URL.createObjectURL(data);
  const downloadLink = document.createElement('a');
  downloadLink.target = "_blank";
  downloadLink.download = filenamePrefix + ".eml";
  downloadLink.href = textFile;
  downloadLink.click();
}

export interface EmailAttachmentBase64 {
  base64EncodedAttachment: string,
  filetype: EmailAttachmentType;
  filename: string
}

export type EmailAttachmentType = 'XLS' | 'PDF' | 'CSV';

function attachmentTypeToContentType(type: EmailAttachmentType) {
  if (type == 'XLS') {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }
  if (type == 'PDF') {
    return 'application/pdf'
  }
  if (type == 'CSV') {
    return 'text/csv'
  }
}

export function openAsHtmlEmailWithPDFAttachment(toAddress: string, ccAddress: string, subject: string, emailBodyHtml: string, filenamePrefix: string, attachments: EmailAttachmentBase64[]) {
  //emailBodyHtml = TemplateSiteDirective.sanitiseHtml(emailBodyHtml);
  const emailBodyAsDom = document.createElement('div');
  emailBodyAsDom.innerHTML = emailBodyHtml;
  TemplateSiteDirective.processDom(emailBodyAsDom);
  emailBodyHtml = emailBodyAsDom.innerHTML;

  var email = "To: " + toAddress + "\n";
  if (ccAddress != null) {
    email += "Cc: " + ccAddress + "\n";
  }
  email += "Subject: " + subject + "\n";
  email += "X-Unsent: 1\n";
  email += "Content-Type: multipart/mixed; boundary=--boundary_text_string\n";
  email += "\n";

  //email body
  email += "----boundary_text_string\n"
  email += "Content-Type: text/html;\n"
  email += "\n";
  email += emailBodyHtml;
  email += "\n";

  //attachment
  for (let attachment of attachments) {
    email += "----boundary_text_string\n"
    email += "Content-Type: " + attachmentTypeToContentType(attachment.filetype) + "; name=" + attachment.filename + "\n"
    email += "Content-Transfer-Encoding: base64\n"
    email += "Content-Disposition: attachment\n";
    email += "\n";
    email += attachment.base64EncodedAttachment;
    email += "\n";

  }
  email += "----boundary_text_string--"

  var data = new Blob([email], { type: 'text/plain' });
  var textFile = window.URL.createObjectURL(data);
  const downloadLink = document.createElement('a');
  downloadLink.target = "_blank";
  downloadLink.download = filenamePrefix + ".eml";
  downloadLink.href = textFile;
  downloadLink.click();
}
